import { bindRequestLogic } from './utils'
import CountryTypes from '../actionTypes/country'
import { countryAPI } from '../api'

const getCountries = bindRequestLogic({
  clientFunc: countryAPI.getCountries,
  type: CountryTypes.GET_COUNTRIES_REQUEST,
  successType: CountryTypes.GET_COUNTRIES_SUCCESS,
  failType: CountryTypes.GET_COUNTRIES_FAILED,
  isQueryParam: true,
  modelName: 'countries'
})

const addCountry = bindRequestLogic({
  clientFunc: countryAPI.addCountry,
  type: CountryTypes.ADD_COUNTRY_REQUEST,
  successType: CountryTypes.ADD_COUNTRY_SUCCESS,
  failType: CountryTypes.ADD_COUNTRY_FAILED
})

const addCountryTranslation = bindRequestLogic({
  clientFunc: countryAPI.addCountryTranslation,
  type: CountryTypes.ADD_COUNTRY_TRANSLATION_REQUEST,
  successType: CountryTypes.ADD_COUNTRY_TRANSLATION_SUCCESS,
  failType: CountryTypes.ADD_COUNTRY_TRANSLATION_FAILED
})

const getCountryDetail = bindRequestLogic({
  clientFunc: countryAPI.getCountryDetail,
  type: CountryTypes.GET_COUNTRY_DETAIL_REQUEST,
  successType: CountryTypes.GET_COUNTRY_DETAIL_SUCCESS,
  failType: CountryTypes.GET_COUNTRY_DETAIL_FAILED,
  modelName: 'country'
})

const deleteCountry = bindRequestLogic({
  clientFunc: countryAPI.deleteCountry,
  type: CountryTypes.DELETE_COUNTRY_REQUEST,
  successType: CountryTypes.DELETE_COUNTRY_SUCCESS,
  failType: CountryTypes.DELETE_COUNTRY_FAILED
})

const updateCountry = bindRequestLogic({
  clientFunc: countryAPI.updateCountry,
  type: CountryTypes.UPDATE_COUNTRY_REQUEST,
  successType: CountryTypes.UPDATE_COUNTRY_SUCCESS,
  failType: CountryTypes.UPDATE_COUNTRY_FAILED
})

const deleteCountryTranslation = bindRequestLogic({
  clientFunc: countryAPI.deleteCountryTranslation,
  type: CountryTypes.DELETE_COUNTRY_TRANSLATION_REQUEST,
  successType: CountryTypes.DELETE_COUNTRY_TRANSLATION_SUCCESS,
  failType: CountryTypes.DELETE_COUNTRY_TRANSLATION_FAILED
})

const updateCountryTranslation = bindRequestLogic({
  clientFunc: countryAPI.updateCountryTranslation,
  type: CountryTypes.UPDATE_COUNTRY_TRANSLATION_REQUEST,
  successType: CountryTypes.UPDATE_COUNTRY_TRANSLATION_SUCCESS,
  failType: CountryTypes.UPDATE_COUNTRY_TRANSLATION_FAILED
})

const getSystemCountries = bindRequestLogic({
  clientFunc: countryAPI.getSystemCountries,
  type: CountryTypes.GET_SYSTEM_COUNTRIES_REQUEST,
  successType: CountryTypes.GET_SYSTEM_COUNTRIES_SUCCESS,
  failType: CountryTypes.GET_SYSTEM_COUNTRIES_FAILED,
  isQueryParam: true
})

export default [
  getCountries,
  addCountry,
  deleteCountry,
  getCountryDetail,
  updateCountry,
  deleteCountryTranslation,
  addCountryTranslation,
  updateCountryTranslation,
  getSystemCountries
]
